import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LANGUAGES } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      // Advertised language URLs (?lang=fr|de|it) always open their language
      const param = new URLSearchParams(window.location.search).get("lang");
      if (param && translations[param]) return param;
      const stored = localStorage.getItem("fp_lang");
      if (stored && translations[stored]) return stored;
    }
    return "de";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("fp_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.de,
      languages: LANGUAGES,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
};
